import { useMutation, UseMutationResult } from '@tanstack/react-query';
import {
  DocumentContentFormatterAPI,
  FormatDocumentContentParams,
} from 'api/semantic-formatting';
import { FormatDocumentContentResponse } from 'api/semantic-formatting';

export const useFormatDocumentContentMutation = (): UseMutationResult<
  FormatDocumentContentResponse,
  Error,
  FormatDocumentContentParams
> => {
  return useMutation({
    mutationFn: (payload: FormatDocumentContentParams) => {
      return DocumentContentFormatterAPI.formatDocumentContent(payload).then(
        (response) => response,
      );
    },
  });
};
